<template>
  <div id="cotacao-resposta" class="cotacao"  v-if="!checkIsEmpty(cotacao)">
    <div class="row m-0">
      <div class="col-12">
        <h1 class="title font-weight-bold text-uppercase">
          Orçamento Respondido
        </h1>
        <hr class="linha-amarela" />
      </div>
      <div class="col-12">
        <div class="card-cotacao">
          <div class="cc-header d-flex">
            <div class="cc-sub-title m-r-25">
              <img
                class="imagem-archive-cotacao"
                src="@/assets/img/icons/file-archive.png"
              />
            </div>
            <div class="cc-sub-title d-flex align-items-center">
              <div v-if="cotacao[0].nome_cotacao !== null">
                Nome:
                <div class="cc-sub-result">
                  {{ cotacao[0].nome_cotacao }}-{{ this.identifier }}
                </div>
              </div>
            </div>
            <div class="cc-sub-line"></div>
            <div class="cc-sub-title d-flex align-items-center">
              <div>
                Data:
                <div class="cc-sub-result">{{ cotacao[0].atualizado_em }}</div>
              </div>
            </div>
            <div class="cc-sub-line"></div>
            <div class="cc-sub-title d-flex align-items-center">
              <div>
                Cód:
                <div class="cc-sub-result">
                  {{ cotacao[0].cot_cotacao_id }}-{{ identifier }}
                </div>
              </div>
            </div>
            <div class="cc-sub-line"></div>
            <div
              v-if="cotacao[0].cot_usuario_enviador_dados.dadosLojista"
              class="cc-sub-title d-flex align-items-center"
            >
              <div>
                Cidade:
                <div class="cc-sub-result">
                  {{
                    cotacao[0].cot_usuario_enviador_dados.dadosLojista.cidade
                      .nome
                  }}
                </div>
              </div>
            </div>
            <div class="cc-sub-line"></div>
            <div class="cc-sub-title d-flex align-items-center">
              <div>
                Preferência:
                <div class="cc-sub-result">
                  {{ cotacao[0].cot_preferencia }}
                </div>
              </div>
            </div>
            <div class="cc-sub-line"></div>
            <div class="cc-sub-title d-flex align-items-center">
              <div>
                Itens Respondidos:
                <div class="cc-sub-result">
                  {{ quantProdutoRespondidos }} de {{ totalProdutos }}
                </div>
              </div>
            </div>
          </div>
          <div class="cc-content p-0" v-if="cotacao[0].produtos !== null">
            <div class="table-responsive">
              <h5 class="text-indent-5px">Inseridos por você!</h5>
              <table class="table table-pedidos">
                <thead>
                  <tr class="tr fs-12">
                    <th class="th">Item</th>
                    <th class="th">Nome</th>
                    <th class="th">Marca</th>
                    <th class="th">Medida</th>
                    <th class="th">Quantidade</th>
                    <th class="th">Undidade</th>
                    <th class="th">Subtotal</th>
                    <!-- <th class="th">Rejeitar ?</th> -->
                    <th class="th">Dúvidas</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="tr fs-14"
                    v-for="(produto, index) in cotacao[0].produtos"
                    :key="index"
                  >
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ index + 1 }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div
                        v-if="
                          produto.disponivel == true && produto.disponivel == 1
                        "
                      >
                        {{ produto.produto_nome }}
                      </div>
                      <div v-else>Não tem {{ produto.produto_nome }}</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.marca_nome">
                        {{ produto.marca_nome }}
                      </div>
                      <div v-else>Sem Marca</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.tipo_medida_nome">
                        {{ produto.tipo_medida_nome }}
                      </div>
                      <div v-else>Sem Medida</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <span class="ml-4">{{ produto.qtd_quantidade }}</span>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ produto.preco_unidades }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ produto.preco_total }}
                    </td>
                    <!-- <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                      v-if="produto.disponivel == true"
                    >
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :id="'rejeitar' + index"
                          v-model="produto.rejeitar"
                          :checked="produto.rejeitar"
                        />
                        <label
                          class="custom-control-label"
                          :for="'rejeitar' + index"
                        >
                          <div v-if="produto.rejeitar == true">Sim</div>
                          <div v-else>Não</div>
                        </label>
                      </div>
                    </td>
                    <td v-else class="td red-font">Não</td> -->
                    <td class="td">
                      <div
                        class="btn-message"
                        @click="
                          verMensagens(
                            dadosUsuario.id,
                            produto.id,
                            cotacao[0].cot_usuario_respondeu_id
                          )
                        "
                      >
                        <i class="fas fa-envelope"></i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            class="cc-content p-0"
            v-if="cotacao[0].produtosImagemArquivo !== null"
          >
            <div class="table-responsive">
              <h5 class="text-indent-5px">Produtos do arquivo</h5>
              <table class="table table-pedidos">
                <thead>
                  <tr class="tr fs-12">
                    <th class="th">Item</th>
                    <th class="th">Nome</th>
                    <th class="th">Marca</th>
                    <th class="th">Medida</th>
                    <th class="th">Quantidade</th>
                    <th class="th">Undidade</th>
                    <th class="th">Subtotal</th>
                    <!-- <th class="th">Rejeitar ?</th> -->
                    <th class="th">Dúvidas</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="tr fs-14"
                    v-for="(produto, index) in cotacao[0].produtosImagemArquivo"
                    :key="index"
                  >
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ index + 1 }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div
                        v-if="
                          produto.disponivel == true && produto.disponivel == 1
                        "
                      >
                        {{ produto.produto_nome }}
                      </div>
                      <div v-else>Não tem {{ produto.produto_nome }}</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ produto.marca_nome }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ produto.medida_nome }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <span class="ml-4">{{ produto.qtd_quantidade }}</span>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ produto.preco_unidades }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ produto.preco_total }}
                    </td>
                    <!-- <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                      v-if="produto.disponivel == true"
                    >
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :id="'rejeitarai' + index"
                          v-model="produto.rejeitar"
                          :checked="produto.rejeitar"
                        />
                        <label
                          class="custom-control-label"
                          :for="'rejeitarai' + index"
                        >
                          <div v-if="produto.rejeitar == true">Sim</div>
                          <div v-else>Não</div>
                        </label>
                      </div>
                    </td>
                    <td v-else class="td red-font">Não</td> -->
                    <td v-bind:class="'td'">
                      <div
                        class="btn-message"
                        @click="
                          verMensagens(
                            dadosUsuario.id,
                            produto.id,
                            cotacao[0].cot_usuario_respondeu_id
                          )
                        "
                      >
                        <i class="fas fa-envelope"></i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="cc-content">
            <!-- Campo de arquivo -->
            <div class="row m-0" v-if="cotacao[0].arquivo !== null">
              <div class="col-12 p-0 m-15px-0px">
                <div
                  class="d-inline-block"
                  v-if="cotacao[0].quantidade_arquivo !== null"
                >
                  Quantidade: {{ cotacao[0].quantidade_arquivo }}
                </div>
                <div
                  class="d-inline-block m-l-20px"
                  v-if="cotacao[0].arquivo !== null"
                >
                  <a
                    :href="`${getImagesAddress}` + cotacao[0].arquivo"
                    class="btn btn-primary c-pointer fs-14 text-uppercase bg-dark-blue"
                    download
                  >
                    Baixar arquivo
                    <i class="fas fa-file-upload m-l-7px"></i>
                  </a>
                </div>
              </div>
            </div>
            <!-- Campo de imagem -->
            <div class="row m-0" v-if="cotacao[0].imagem !== null">
              <div class="col-12 p-0 m-15px-0px">
                <div
                  class="d-inline-block"
                  v-if="cotacao[0].quantidade_foto !== null"
                >
                  Quantidade: {{ cotacao[0].quantidade_foto }}
                </div>
                <DownloadImages :allImages="this.cotacao[0].imagem" />
              </div>
            </div>
          </div>
          <div class="cc-content">
            <div class="row m-0">
              <div class="col-3 p-0" v-if="!checkIsEmpty(cotacao[0].cot_cep)">
                <b class="font-weight-bold text-uppercase fs-14"
                  >CEP de entrega:</b
                >
                {{ cotacao[0].cot_cep }}
              </div>
              <div class="col-5 p-0" v-else>
                <b class="font-weight-bold text-uppercase fs-14"
                  >Retira na Loja</b
                >
              </div>
              <div
                class="col-2"
                v-if="!checkIsEmpty(cotacao[0].cot_cep)"
              >
                <b class="font-weight-bold text-uppercase fs-14">Frete:</b>
                {{ cotacao[0].cot_frete }}
              </div>
              <div
                class="col-7 p-0 text-right"
              >
                <b class="font-weight-bold text-uppercase fs-14"
                  >Prazo de entrega após confirmação do pagamento:</b
                >
                Até {{ cotacao[0].cot_prazo }} dia(s)
              </div>
            </div>
          </div>
          <div class="cc-content">
            <h5><strong>Valor Total</strong></h5>
            <PaymentForm :idQuote="this.id" />
          </div>

          <div class="container">
            <!-- <div class="condicoes-pagamento-entrega">
              <b class="font-weight-bold text-uppercase fs-14"
                >Condições de Pagamento:</b
              >
              {{ cotacao[0].cot_cond_pagamentos }}
            </div> -->
          </div>
          <div class="cc-content">
            <div class="condicoes-pagamento-entrega">
              <b class="font-weight-bold text-uppercase fs-14"
                >Orçamento válido até:</b
              >
              {{ cotacao[0].cot_validade }}
            </div>
          </div>
          <div class="cc-footer">
            <div
              class="position-relative row m-0 p-10 text-right linha-abaixo-cinza"
            >
              <div class="col-6 p-0 text-left">
                <div id="btn-id" class="btn-aprovar" @click="prosseguirPagamento()">
                  Prosseguir para o pagamento
                </div>
                <div id="text-expired" class="d-inline ml-3 h5 text-danger">

                </div>
              </div>
              <div class="col-6 p-0 text-right">
                <div class="btn-voltar" @click="voltarCotacao()">Voltar</div>
              </div>
            </div>
            <div class="position-relative p-10 text-left">
              <div class="row m-0">
                <div class="col-1 p-0">
                  <div class="btn-rejeitar" @click="rejeitarCotacao()">
                    Rejeitar
                  </div>
                </div>
                <div class="col-11 p-0">
                  <div class="form-group row m-0">
                    <label
                      for="cotacaoRespostaMotivo"
                      class="col-sm-2 col-form-label text-right font-weight-bold text-uppercase fs-14"
                      >Motivos</label
                    >
                    <div class="col-sm-10 p-0">
                      <input
                        type="text"
                        :class="motivo.class"
                        id="cotacaoRespostaMotivo"
                        v-model="motivo.valor"
                        placeholder="Insira os motivos nesse campo caso vá rejeitar."
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 d-flex align-items-center justify-content-center">
        <Paginate
          class="mt-4"
          routeNameToPush="cliente-cotacao-respondida"
          :nextQuote="getAnsweredQuotesIds[calculateNextQuoteId]"
          :previousQuote="getAnsweredQuotesIds[calculatePreviousQuoteId]"
        />
      </div>
    </div>
    <b-modal id="comentarios" ref="comentarios" title="Comentarios" hide-footer>
      <template slot="modal-title">Dúvidas sobre esse produto</template>
      <div class="d-block text-center">
        <div class="limit_comentarios">
          <div
            class="comentarios_mensagens"
            v-for="(mensagem, index) in mensagensCotacao"
            :key="index"
          >
            <div
              class="row m-0"
              v-if="mensagem.usuario_enviador_id !== dadosUsuario.id"
            >
              <div class="tipo col-3 p-0">
                {{ mensagem.usuario_enviador.tipo_usuario.nome }}
              </div>
              <div class="mensagem col-9 p-0 text-left fs-14">
                {{ mensagem.mensagem }}
              </div>
            </div>
            <div class="row m-0" v-else>
              <div class="mensagem col-9 p-0 text-right fs-14">
                {{ mensagem.mensagem }}
              </div>
              <div class="tipo col-3 p-0">
                {{ mensagem.usuario_enviador.tipo_usuario.nome }}
              </div>
            </div>
          </div>
        </div>
        <div class="caixa_texto_mensagem">
          <div class="row m-0">
            <div class="col-9 p-j-right-10px">
              <textarea
                class="caixa_texto fs-12"
                placeholder="Digite sua dúvida e clique em anexar!"
                v-model="mensagem"
              ></textarea>
            </div>
            <div class="col-3 p-j-left-10px">
              <div
                class="btn btn-envio-mensagem"
                @click="
                  enviarMensagemProd(
                    dadosUsuario.id,
                    cotacao[0].id,
                    dadosUsuario.id !== cotacao[0].cot_usuario_respondeu_id
                      ? cotacao[0].cot_usuario_respondeu_id
                      : cotacao[0].cot_usuario_receb_resp_id
                  )
                "
              >
                Anexar
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-button class="mt-3" block @click="$bvModal.hide('comentarios')"
        >Fechar</b-button
      >
    </b-modal>
    <b-modal
      title="Finalize seu cadastro"
      size="xl"
      id="finishRegister"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      no-close-on-backdrop
    >
      <div
        class="row container"
        v-if="dadosUsuario.informacoes.tipo_cliente === 1"
      >
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="cpf"> CPF </label>
            <input
              type="text"
              class="form-control"
              id="cpf"
              name="cpf"
              v-model="FinishRegister.cpf"
              v-mask="'###.###.###-##'"
              aria-describedby="CPF para Cadastro"
              placeholder="Digite seu CPF"
              @input="ErrorMessages.cpf = null"
            />
            <p
              class="error-message text-danger"
              v-if="ErrorMessages.cpf !== null"
            >
              {{ ErrorMessages.cpf }}
            </p>
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="rg"> RG (opcional) </label>
            <input
              type="text"
              class="form-control"
              id="rg"
              name="rg"
              v-model="FinishRegister.rg"
              v-mask="'##.###.###-X'"
              aria-describedby="RG para Cadastro"
              placeholder="Digite seu RG"
              @input="ErrorMessages.rg = null"
            />
            <p
              class="error-message text-danger"
              v-if="ErrorMessages.rg !== null"
            >
              {{ ErrorMessages.rg }}
            </p>
          </div>
        </div>
      </div>

      <div class="col-12" v-if="dadosUsuario.informacoes.tipo_cliente === 2">
        <div class="form-group">
          <label for="cnpj"> CNPJ </label>
          <input
            type="text"
            class="form-control"
            id="cnpj"
            name="cnpj"
            v-model="FinishRegister.cnpj"
            v-mask="'##.###.###/####-##'"
            aria-describedby="CNPJ para Cadastro"
            placeholder="Digite seu CNPJ"
            @input="ErrorMessages.cnpj = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.cnpj !== null"
          >
            {{ ErrorMessages.cnpj }}
          </p>
        </div>
      </div>

      <div class="col-12">
        <div class="form-group">
          <label for="endereco"> Endereço </label>
          <input
            type="text"
            class="form-control"
            id="endereco"
            name="endereco"
            v-model="FinishRegister.endereco"
            aria-describedby="Endereço para Cadastro"
            placeholder="Digite seu Endereço"
            @input="ErrorMessages.address = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.address !== null"
          >
            {{ ErrorMessages.address }}
          </p>
        </div>
      </div>
      <div class="row container">
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="numero"> Número </label>
            <input
              type="numeric"
              class="form-control"
              id="numero"
              name="numero"
              v-model="FinishRegister.numero"
              v-mask="'####'"
              aria-describedby="Número para Cadastro"
              placeholder="Digite seu Número"
              @input="ErrorMessages.number = null"
            />
            <p
              class="error-message text-danger"
              v-if="ErrorMessages.number !== null"
            >
              {{ ErrorMessages.number }}
            </p>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="cep"> CEP </label>
            <input
              type="text"
              class="form-control"
              id="cep"
              name="cep"
              v-model="FinishRegister.cep"
              v-mask="'#####-###'"
              aria-describedby="CEP para Cadastro"
              placeholder="Digite seu CEP"
              @input="ErrorMessages.cep = null"
            />
            <p
              class="error-message text-danger"
              v-if="ErrorMessages.cep !== null"
            >
              {{ ErrorMessages.cep }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="form-group">
          <label for="complemento"> Complemento (opcional) </label>
          <input
            type="text"
            class="form-control"
            id="complemento"
            name="complemento"
            v-model="FinishRegister.complemento"
            aria-describedby="Complemento para Cadastro"
            placeholder="Digite seu Complemento"
          />
        </div>
      </div>
      <div class="col-12">
        <div class="form-group">
          <label for="bairro"> Bairro </label>
          <input
            type="text"
            class="form-control"
            id="bairro"
            name="bairro"
            v-model="FinishRegister.bairro"
            aria-describedby="Bairro para cadastro"
            placeholder="Digite o bairro"
            @input="ErrorMessages.neighborhood = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.neighborhood !== null"
          >
            {{ ErrorMessages.neighborhood }}
          </p>
        </div>
      </div>
      <div class="row container">
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="celular"> WhatsApp (opcional) </label>
            <input
              type="text"
              class="form-control"
              id="celular"
              name="celular"
              v-model="FinishRegister.celular"
              v-mask="['(##) #####-####', '(##) ####-####']"
              placeholder="Digite o seu Whatsapp"
              @input="ErrorMessages.cellphone = null"
            />
            <p
              class="error-message text-danger"
              v-if="ErrorMessages.cellphone !== null"
            >
              {{ ErrorMessages.cellphone }}
            </p>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="telefone2"> Telefone 2 (opcional) </label>
            <input
              type="text"
              class="form-control"
              id="telefone2"
              name="telefone2"
              v-model="FinishRegister.telefone2"
              v-mask="['(##) #####-####', '(##) ####-####']"
              aria-describedby="Bairro para cadastro"
              placeholder="Digite o 2º telefone"
              @input="ErrorMessages.telephone2 = null"
            />
            <p
              class="error-message text-danger"
              v-if="ErrorMessages.telephone2 !== null"
            >
              {{ ErrorMessages.telephone2 }}
            </p>
          </div>
        </div>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100">
          <button
            type="button"
            class="btn btn-success btn-lg float-right"
            @click="finishRegister()"
          >
            Finalizar
            <i class="fas fa-check-circle ml-2"></i>
          </button>
        </div>
        
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import makeToast from '../../mixins/makeToast';
import DownloadImages from '../../components/DownloadImages.vue';
import SendQuestionButton from '../../components/SendQuestionButton.vue';
import Paginate from '../../components/Quote/Paginate.vue';
import PaymentForm from '../../components/PaymentForm.vue';

export default {
  name: 'cotacao-resposta',
  watch: {
    id() {
      this.loadQuote();
    },
  },
  mixins: [makeToast],
  components: {
    DownloadImages,
    SendQuestionButton,
    Paginate,
    PaymentForm,
},
  data: () => ({
    faturas: [],
    items: [],
    errors: [],
    produtosSA: null,
    mensagem: null,
    mensagemProdId: null,
    motivo: {
      valor: null,
      mensagem: null,
      class: 'form-control',
    },
    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      suffix: '',
      precision: 2,
      masked: true,
    },
    FinishRegister: {
      cpf: null,
      rg: null,
      cnpj: null,
      endereco: null,
      numero: null,
      complemento: null,
      cep: null,
      bairro: null,
      celular: null,
      telefone2: null,
    },
    ErrorMessages: {
      cpf: null,
      rg: null,
      cnpj: null,
      address: null,
      number: null,
      cep: null,
      neighborhood: null,
      cellphone: null,
      telephone2: null,
    },
  }),
  created() {
    if (this.checkIsEmpty(this.dadosUsuario)) {
      this.$router.push({ name: 'area-restrita' });
    }

    this.loadQuote();
  },
  props: ['id', 'identifier'],
  computed: {
    ...mapGetters('general', ['getImagesAddress']),
    currentQuoteIdIndex() {
      return this.getAnsweredQuotesIds.findIndex(
        ({ quoteId, quoteIdentifier }) =>
          quoteId === this.id && quoteIdentifier === this.identifier
          
      );
    },
    calculateNextQuoteId() {
      return this.currentQuoteIdIndex + 1;
    },
    calculatePreviousQuoteId() {
      return this.currentQuoteIdIndex - 1;
    },
    ...mapGetters(['getTipoNotification', 'getNotification']),
    ...mapGetters('quote', ['getAnsweredQuotesIds']),
    ...mapState({
      cotacoes: (state) => state.cotacoes,
      cotacao: (state) => state.cotacao,
      dadosUsuario: (state) => state.dadosUsuario,
      mensagensCotacao: (state) => state.mensagensCotacao,
      valorTotal(state) {
        if (state.cotacao.length > 0) {
          let valorTotal = 0;
          let valorAnterior = 0;
          if (!this.checkIsEmpty(state.cotacao[0].produtos)) {
            if (state.cotacao[0].produtos.length > 0) {
              for (const produto in state.cotacao[0].produtos) {
                let valorString = String(
                  state.cotacao[0].produtos[produto].preco_unidades_sem_mascara
                );
                valorString = parseFloat(valorString.replace(/[\D]+/g, ''));
                valorAnterior +=
                  parseFloat(valorString) *
                  parseFloat(state.cotacao[0].produtos[produto].qtd_quantidade);
                if (
                  (state.cotacao[0].produtos[produto].disponivel === 1 ||
                    state.cotacao[0].produtos[produto].disponivel === true) &&
                  (state.cotacao[0].produtos[produto].rejeitar === 0 ||
                    state.cotacao[0].produtos[produto].rejeitar === false)
                ) {
                  valorTotal +=
                    parseFloat(valorString) *
                    parseFloat(
                      state.cotacao[0].produtos[produto].qtd_quantidade
                    );
                } else {
                  valorAnterior -=
                    parseFloat(valorString) *
                    parseFloat(
                      state.cotacao[0].produtos[produto].qtd_quantidade
                    );
                }
              }
            }
          }
          if (!this.checkIsEmpty(state.cotacao[0].produtosImagemArquivo)) {
            if (state.cotacao[0].produtosImagemArquivo.length > 0) {
              for (const produto in state.cotacao[0].produtosImagemArquivo) {
                valorAnterior +=
                  parseFloat(
                    state.cotacao[0].produtosImagemArquivo[produto]
                      .preco_unidades_sem_mascara
                  ) *
                  parseFloat(
                    state.cotacao[0].produtosImagemArquivo[produto]
                      .produto_quantidade
                  );
                if (
                  (state.cotacao[0].produtosImagemArquivo[produto]
                    .disponivel === 1 ||
                    state.cotacao[0].produtosImagemArquivo[produto]
                      .disponivel === true) &&
                  (state.cotacao[0].produtosImagemArquivo[produto].rejeitar ===
                    0 ||
                    state.cotacao[0].produtosImagemArquivo[produto].rejeitar ===
                      false)
                ) {
                  valorTotal +=
                    parseFloat(
                      state.cotacao[0].produtosImagemArquivo[produto]
                        .preco_unidades_sem_mascara
                    ) *
                    parseFloat(
                      state.cotacao[0].produtosImagemArquivo[produto]
                        .produto_quantidade
                    );
                } else {
                  valorAnterior -=
                    parseFloat(
                      state.cotacao[0].produtosImagemArquivo[produto]
                        .preco_unidades_sem_mascara
                    ) *
                    parseFloat(
                      state.cotacao[0].produtosImagemArquivo[produto]
                        .produto_quantidade
                    );
                }
              }
            }
          }
          return (
            valorAnterior + parseFloat(state.cotacao[0].cot_frete_sem_mascara)
          );
        }
        return 0;
      },
      totalProdutos(state) {
        if (state.cotacao.length > 0) {
          let quantProdutos = 0;
          if (!this.checkIsEmpty(state.cotacao[0].produtos)) {
            if (state.cotacao[0].produtos.length > 0) {
              quantProdutos += state.cotacao[0].produtos.length;
            }
          }
          if (!this.checkIsEmpty(state.cotacao[0].produtosImagemArquivo)) {
            if (state.cotacao[0].produtosImagemArquivo.length > 0) {
              quantProdutos += state.cotacao[0].produtosImagemArquivo.length;
            }
          }
          return quantProdutos;
        }
      },
      quantProdutoRespondidos(state) {
        if (state.cotacao.length > 0) {
          let quantProdutos = 0;
          if (!this.checkIsEmpty(state.cotacao[0].produtos)) {
            if (state.cotacao[0].produtos.length > 0) {
              for (const produto in state.cotacao[0].produtos) {
                if (
                  (state.cotacao[0].produtos[produto].disponivel === 1 ||
                    state.cotacao[0].produtos[produto].disponivel === true) &&
                  (state.cotacao[0].produtos[produto].rejeitar === 0 ||
                    state.cotacao[0].produtos[produto].rejeitar === false)
                ) {
                  quantProdutos++;
                }
              }
            }
          }
          if (!this.checkIsEmpty(state.cotacao[0].produtosImagemArquivo)) {
            if (state.cotacao[0].produtosImagemArquivo.length > 0) {
              for (const produto in state.cotacao[0].produtosImagemArquivo) {
                if (
                  (state.cotacao[0].produtosImagemArquivo[produto]
                    .disponivel === 1 ||
                    state.cotacao[0].produtosImagemArquivo[produto]
                      .disponivel === true) &&
                  (state.cotacao[0].produtosImagemArquivo[produto].rejeitar ===
                    0 ||
                    state.cotacao[0].produtosImagemArquivo[produto].rejeitar ===
                      false)
                ) {
                  quantProdutos++;
                }
              }
            }
          }
          return quantProdutos;
        }
      },
    }),
  },
  mounted() {
    this.loadCheckout();
  },
  methods: {
    loadQuote() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('emptyCotacao').then(() => {
        this.$store
          .dispatch('showCotacaoRespondida', this.id)
          .catch(() => {
            this.$store.dispatch('endLoader');
            this.makeToast(
              'Oops!',
              'Não foi possível carregar os orçamento! Tente novamente em 5 minutos!',
              'danger'
            );
          })
          .finally(() => this.$store.dispatch('endLoader'));
      });
    },


    loadCheckout() {
    setTimeout(() => {
      const value = {
        id: this.cotacao[0].cot_cotacao_id,
        shop: this.cotacao[0].cot_usuario_respondeu_id
      };
      this.$store
        .dispatch('showCheckout', value)
        .then((resp) => {
          const response = resp.data;
          this.faturas = response;
        });
    }, 2000);
    },
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
    voltarCotacao() {
      this.$router.push({
        name: 'cliente-respondidas',
      });
    },
    verMensagens(UsuarioEnviador, produtoId) {
      const data = {
        id: produtoId,
        usuarioId: UsuarioEnviador,
      };
      this.mensagemProdId = produtoId;
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('showMensagensCotacaoRespostaAtt', data)
        .then(() => {
          setTimeout(() => {
            this.$store.dispatch('endLoader');
            this.$bvModal.show('comentarios');
          }, 1500);
        })
        .catch(() => {
          this.$store.dispatch('endLoader');
        });
    },
    enviarMensagemProd(UsuarioEnviador, cotacaoId, UsuarioRecebedor) {
      const self = this;
      const data = {
        usuario_enviador_id: UsuarioEnviador,
        cotacao_resposta_id: cotacaoId,
        cotacao_produto_id: this.mensagemProdId,
        usuario_recebedor_id: UsuarioRecebedor,
        mensagem: this.mensagem,
      };
      this.$store.dispatch('insertMensagem', data).then(() => {
        setTimeout(() => {
          if (this.getTipoNotification === 1) {
            this.aviso('Sua dúvida foi anexada com sucesso!', 'success');
          } else if (this.getTipoNotification === 3) {
            this.aviso(this.getNotification, 'danger');
          }
          this.$store.dispatch(
            'showMensagensCotacaoResposta',
            self.mensagemProdId
          );
          this.mensagem = null;
        }, 1000);
      });
    },
    retirarAvisos() {
      this.errors = [];
      this.motivo.class = 'form-control';
    },
    responderCotacao() {
      const objcotacao = { ...this.cotacao[0] };
      const responderCotacao = {
        id: objcotacao.id,
        usuario_enviador_id: this.dadosUsuario.id,
        usuario_recebedor_id: objcotacao.cot_usuario_respondeu_id,
        valor_total: this.valorTotal,
        produtos: [],
      };
      if (objcotacao.produtos !== null) {
        for (const item of objcotacao.produtos) {
          responderCotacao.produtos.push(item);
        }
      }
      if (objcotacao.produtosImagemArquivo !== null) {
        for (const item of objcotacao.produtosImagemArquivo) {
          responderCotacao.produtos.push(item);
        }
      }
      if (this.dadosUsuario.id !== objcotacao.cot_usuario_respondeu_id) {
        this.$store.dispatch('startLoader');
        this.$store
          .dispatch('updateCotacaoResposta', responderCotacao)
          .then(() => {
            setTimeout(() => {
              this.$store.dispatch('endLoader');
              this.aviso('Cotação respondida com sucesso!', 'success');
              setTimeout(() => {
                this.$router.push({ name: 'cliente-meus-dados' });
              }, 1000);
            }, 1500);
          })
          .catch(() => {
            this.$store.dispatch('endLoader');
            this.aviso('Houve um problema em responder a cotação!', 'success');
          });
      } else {
        this.aviso('Você já enviou sua resposta!', 'warning');
        this.aviso('Espere até que o lojista responda!', 'warning');
        this.$bvModal.hide('confirmQuestion');
      }
    },
    prosseguirPagamento() {
      const dateCot = new Date();
      const dia = String(dateCot.getDate()).padStart(2, '0');
      const mes = String(dateCot.getMonth() + 1).padStart(2, '0');
      const ano = dateCot.getFullYear();
      const dataAtual = ano + '-' + mes + '-' + dia;
      if(dataAtual <= this.cotacao[0].cot_validade_sem_mascara) {
      this.$router.push({
        name: 'cliente-cotacao-pagamento',
        params: { id: this.cotacao[0].id }
          
      })} else {
        const cotButton = document.getElementById('btn-id').style.background="#81D381"
        const messageExpired = document.getElementById('text-expired').innerHTML='Orçamento vencido'
      }
    },
    aprovarCotacao() {
      if (this.dadosUsuario.informacoes.tipo_cliente !== null) {
        if (
          this.checkIsEmpty(this.dadosUsuario.cpf) &&
          this.checkIsEmpty(this.dadosUsuario.cnpj)
        ) {
          this.showModal();
          return false;
        }
      }
      const values = {
        id: this.cotacao[0].id,
        idCotacao: this.cotacao[0].cot_cotacao_id,
        valor_total: this.valorTotal,
        produtosRejeitados: [],
      };
      if (
        this.cotacao[0].produtos !== null &&
        this.cotacao[0].produtos !== 'null'
      ) {
        for (const produto of this.cotacao[0].produtos) {
          if (produto.rejeitar === true) {
            values.produtosRejeitados.push(produto.id);
          }
        }
      }
      if (
        this.cotacao[0].produtosImagemArquivo !== null &&
        this.cotacao[0].produtosImagemArquivo !== 'null'
      ) {
        for (const produto of this.cotacao[0].produtosImagemArquivo) {
          if (produto.rejeitar === true) {
            values.produtosRejeitados.push(produto.id);
          }
        }
      }
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('updateCotacaoAprovacao', values)
        .then(() => {
          setTimeout(() => {
            this.$store.dispatch('endLoader');
            if (this.getTipoNotification === 1) {
              this.aviso('Cotação aprovada com sucesso!', 'success');
              setTimeout(() => {
                this.$router.push({
                  name: 'cliente-cotacao-aprovada',
                  id: this.cotacao[0].id,
                });
              }, 1500);
            } else if (this.getTipoNotification === 3) {
              this.aviso(
                'Houve um problema em aprovar essa cotação!',
                'danger'
              );
            }
          }, 1000);
        })
        .catch(() => {
          this.$store.dispatch('endLoader');
          this.aviso(
            'Não foi possível aprovar essa cotação, tente novamente em 5 minutos!',
            'danger'
          );
        });
    },
    rejeitarCotacao() {
      if (this.checkIsEmpty(this.motivo.valor)) {
        this.aviso(
          'É necessário escrever o motivo para rejeitar essa cotação!',
          'warning'
        );
      } else {
        const values = {
          id: this.cotacao[0].id,
          idCotacao: this.cotacao[0].cot_cotacao_id,
          motivo_rejeicao: this.motivo.valor,
          usuario_enviador_id: this.dadosUsuario.id,
          usuario_recebedor_id:
            this.dadosUsuario.id !== this.cotacao[0].cot_usuario_receb_resp_id
              ? this.cotacao[0].cot_usuario_receb_resp_id
              : this.cotacao[0].cot_usuario_respondeu_id,
        };
        this.$store.dispatch('startLoader');
        this.$store
          .dispatch('updateCotacaoRejeitacao', values)
          .then(() => {
            setTimeout(() => {
              this.$store.dispatch('endLoader');
              if (this.getTipoNotification === 1) {
                this.aviso(this.getNotification, 'success');
                setTimeout(() => {
                  this.$router.push({ name: 'cliente-meus-dados' });
                }, 1500);
              } else if (this.getTipoNotification === 3) {
                this.aviso(this.getNotification, 'danger');
              }
            }, 1000);
          })
          .catch(() => {
            this.$store.dispatch('endLoader');
          });
      }
    },
    subValor(valor, quantidade) {
      let valorString = String(valor);
      if (quantidade === null) {
        valorString = parseInt(valorString.replace(/[\D]+/g, '')) * parseInt(0);
      } else {
        valorString =
          parseInt(valorString.replace(/[\D]+/g, '')) * parseInt(quantidade);
      }
      return valorString;
    },
    aviso(texto, tipo) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    finishRegister() {
      if (this.validateFields()) {
        this.$store.dispatch('startLoader');
        const userData = {
          usuario_id: this.dadosUsuario.informacoes.usuario_id,
          id: this.dadosUsuario.informacoes.id,
        };
        Object.assign(this.FinishRegister, userData);
        this.$store
          .dispatch('client/finishClientRegister', this.FinishRegister)
          .then(() => {
            this.$store.dispatch('endLoader');
            this.setNewUserData();
            this.makeToast('Sucesso!', 'Cadastro finalizado com sucesso!');
            this.$bvModal.hide('finishRegister');
            this.aprovarCotacao();
          })
          .catch(() => {
            this.$store.dispatch('endLoader');
            this.makeToast(
              'Oopss!',
              'Parece que houve um erro ao atualizar, verifique os campos e tente novamente',
              'danger'
            );
          });
      } else {
        this.makeToast(
          'Oopss!',
          'Parece que há campos inválidos! Corrija-os e tente novamente',
          'danger'
        );
      }
    },
    validateFields() {
      let isValid = true;
      if (this.dadosUsuario.informacoes.tipo_cliente === 1) {
        if (
          this.FinishRegister.rg !== null &&
          this.FinishRegister.rg !== '' &&
          !this.$validate.rg(this.FinishRegister.rg)
        ) {
          this.ErrorMessages.rg = 'RG inválido';
          isValid = false;
        }
        if (!this.$validate.cpf(this.FinishRegister.cpf)) {
          this.ErrorMessages.cpf = 'CPF inválido';
          isValid = false;
        }
      }
      if (this.dadosUsuario.informacoes.tipo_cliente === 2) {
        if (!this.$validate.cnpj(this.FinishRegister.cnpj)) {
          this.ErrorMessages.cnpj = 'CNPJ inválido';
          isValid = false;
        }
      }
      if (!this.$validate.address(this.FinishRegister.endereco)) {
        this.ErrorMessages.address =
          'Endereço inválido, digite um com no mínimo 5 e no máximo 70 caracteres';
        isValid = false;
      }
      if (!this.$validate.cep(this.FinishRegister.cep)) {
        this.ErrorMessages.cep = 'CEP inválido';
        isValid = false;
      }
      if (!this.$validate.neighborhood(this.FinishRegister.bairro)) {
        this.ErrorMessages.neighborhood =
          'Bairro inválido, digite com no máximo 40 caracteres';
        isValid = false;
      }
      if (!this.$validate.addressNumber(this.FinishRegister.numero)) {
        this.ErrorMessages.number =
          'Número inválido, digite somente números de 1 à 4 caracteres';
        isValid = false;
      }
      if (
        this.FinishRegister.celular !== null &&
        this.FinishRegister.celular !== '' &&
        !this.$validate.telephone(this.FinishRegister.celular)
      ) {
        this.ErrorMessages.cellphone = 'WhatsApp inválido';
        isValid = false;
      }
      if (
        this.FinishRegister.telefone2 !== null &&
        this.FinishRegister.telefone2 !== '' &&
        !this.$validate.telephone(this.FinishRegister.telefone2)
      ) {
        this.ErrorMessages.telephone2 = 'Telefone 2 inválido';
        isValid = false;
      }
      return isValid;
    },
    async setNewUserData() {
      this.$store.dispatch('startLoader');
      const currentUserData = this.dadosUsuario;
      currentUserData.cpf = this.FinishRegister.cpf;
      currentUserData.cnpj = this.FinishRegister.cnpj;
      currentUserData.rg = this.FinishRegister.rg;
      currentUserData.informacoes.endereco = this.FinishRegister.endereco;
      currentUserData.informacoes.numero = this.FinishRegister.numero;
      currentUserData.informacoes.complemento = this.FinishRegister.complemento;
      currentUserData.informacoes.cep = this.FinishRegister.cep;
      currentUserData.informacoes.bairro = this.FinishRegister.bairro;
      currentUserData.informacoes.celular = this.FinishRegister.celular;
      currentUserData.informacoes.telefone2 = this.FinishRegister.telefone2;
      await this.$store.commit('setDadosUsuario', currentUserData);
      localStorage.removeItem('dadosUsuario');
      localStorage.setItem('dadosUsuario', JSON.stringify(currentUserData));
      this.$store.dispatch('endLoader');
    },
    showModal() {
      this.$bvModal.show('finishRegister');
    },
  },
};
</script>

<style>
@import '../../custom/css/cotacao.css';
div.form-group + label {
  font-weight: 700;
}
.error-message {
  display: flex;
  align-items: center;
  padding: 6px 12px;
  background-color: #f8d7da;
  border-radius: 0 0 5px 5px;
}
.cotacao-div {
  text-align: center;
  color: gray;
  font-size: 1.3em;
  transform: translateY(+35%);
  margin-top: -2%;
}
</style>
